
const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'BePie',
  props: {
    data: {
      type: Array,
      default: () => [
        { value: '1048', name: 'Search Engine' },
        { value: '735', name: 'Direct' },
        { value: '580', name: 'Email' },
        { value: '484', name: 'Union Ads' },
        { value: '300', name: 'Video Ads' }
      ]
    },
    title: { type: String, default: () => '标题' },
    name: { type: String, default: () => '' },
    colors: { type: Array, default: () => ['#fe4ecd', '#2697ff', '#4fffff', '#892bfe'] },
    type: { type: String, default: () => 'pie' },
    radius: { type: Array, default: () => ['50%', '80%'] },
    roseType: { type: String, default: () => '' },
    fontSize: { type: String, default: () => '12' },
    showLegend: { type: Boolean, default: () => true },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      option: {},
    }
  },
  watch: {
    data(next, prev) {
      if (JSON.stringify(next) != JSON.stringify(prev)) this.create();
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      let series = [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: this.data,
        }
      ];
      this.option = {
        backgroundColor: this.backgroundColor,
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        grid: {
          top: this.showLegend ? (this.fontSize * 3) : 0,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
          textStyle: {
            fontSize: this.fontSize,
          },
        },
        legend: {
          show: this.showLegend,
          orient: 'horizontal',
          data: this.data.map(a => a.name),
        },
        calculable: true,
        tooltip: {
          trigger: 'item'
        },
        series,
      };
    },
  },
  render() {
    const { option = {}, delay = 400, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={delay} {...{ attrs }} />);
  }
}